jQuery(document).ready(function($){
    function resize_process_slider() {
        let max_height = 0;
        $('.nf-process-slider__slides__item').each(function(){
            if ( $(this).outerHeight(true) > max_height ) {
                max_height = $(this).outerHeight(true);
            }
        });
        $('.nf-process-slider__slides').height(max_height + 50);
    }
    
    resize_process_slider();
    
    $(window).resize(function(){
        resize_process_slider();
    });
    
    class ProcessSlider {
        rotateImage = (direction) => {
            let current_angle = $('.nf-process-slider__rotator img').css( 'rotate' );
            current_angle = parseInt( current_angle.replace('deg', '') );
            
            if ( direction === 'next' ) {
                current_angle = current_angle + 90;
            }
            else {
                current_angle = current_angle - 90;
            }
            
            $('.nf-process-slider__rotator img').css( 'rotate', current_angle + 'deg' );
        }
        
        init = () => {
            const that = this;
            
            let current = $('.nf-process-slider__slides__item.active');
            current.next().css('top', '70%');
            $('.nf-process-slider__slides__item').last().css('top', '30%');
            
            let num_of_slides = $('.nf-process-slider__slides__item').length;
            
            $('.nf-process-slider__slides__nav__next').on('click', function(e){
                e.preventDefault();
                
                let next_name = $('.nf-process-slider__rotator__names span.active').next('span');
                if ( next_name.length === 0 ) {
                    next_name = $('.nf-process-slider__rotator__names span').first();
                }
                $('.nf-process-slider__rotator__names span.active').removeClass('active').addClass('inactive');
                next_name.removeClass('inactive').addClass('active');
                
                let next = current.next('.nf-process-slider__slides__item');
                
                if (next.length === 0) {
                    next = $('.nf-process-slider__slides__item').first();
                }
                
                current.css('top', '30%');
                current.removeClass('active').addClass('inactive');
                
                next.removeClass('inactive').addClass('active');
                current = next;
                
                that.rotateImage('next');
                
                if ( current.index() + 1 === num_of_slides ) {
                    $('.nf-process-slider__slides__nav__next').css('opacity', '0');
                    $('.nf-process-slider__slides__nav__next').css('pointer-events', 'none');
                }
                
                if ( current.index() !== 0 ) {
                    $('.nf-process-slider__slides__nav__prev').css('opacity', '1');
                    $('.nf-process-slider__slides__nav__prev').css('pointer-events', 'all');
                }
                
                setTimeout(function(){
                    $('.nf-process-slider__slides__item.active').nextAll('.nf-process-slider__slides__item').css('top', '70%');
                    $('.nf-process-slider__slides__item.active').prevAll('.nf-process-slider__slides__item').css('top', '30%');
                    
                    if ( $('.nf-process-slider__slides__item.active').index() === 0 ) {
                        $('.nf-process-slider__slides__item').last().css('top', '30%');
                    }
                    
                    if ( $('.nf-process-slider__slides__item.active').index() + 1 === num_of_slides ) {
                        $('.nf-process-slider__slides__item').first().css('top', '70%');
                    }
                }, 300);
            });
            
            $('.nf-process-slider__slides__nav__prev').on('click', function(e){
                e.preventDefault();
                
                let prev_name = $('.nf-process-slider__rotator__names span.active').prev('span');
                if ( prev_name.length === 0 ) {
                    prev_name = $('.nf-process-slider__rotator__names span').last();
                }
                $('.nf-process-slider__rotator__names span.active').removeClass('active').addClass('inactive');
                prev_name.removeClass('inactive').addClass('active');
                
                let prev = current.prev('.nf-process-slider__slides__item');
                
                if (prev.length === 0) {
                    prev = $('.nf-process-slider__slides__item').last();
                }
                
                current.css('top', '70%');
                current.removeClass('active').addClass('inactive');
                
                prev.removeClass('inactive').addClass('active');
                current = prev;
                
                that.rotateImage('prev');
                
                if ( current.index() === 0 ) {
                    $('.nf-process-slider__slides__nav__prev').css('opacity', '0');
                    $('.nf-process-slider__slides__nav__prev').css('pointer-events', 'none');
                }
                
                if ( current.index() + 1 !== num_of_slides ) {
                    $('.nf-process-slider__slides__nav__next').css('opacity', '1');
                    $('.nf-process-slider__slides__nav__next').css('pointer-events', 'all');
                }
                
                setTimeout(function(){
                    $('.nf-process-slider__slides__item.active').nextAll('.nf-process-slider__slides__item').css('top', '70%');
                    $('.nf-process-slider__slides__item.active').prevAll('.nf-process-slider__slides__item').css('top', '30%');
                    
                    if ( $('.nf-process-slider__slides__item.active').index() === 0 ) {
                        $('.nf-process-slider__slides__item').last().css('top', '30%');
                        $('.nf-process-slider__slides__item').first().css('top', '70%');
                    }
                    
                    if ( $('.nf-process-slider__slides__item.active').index() + 1 === num_of_slides ) {
                        $('.nf-process-slider__slides__item').first().css('top', '70%');
                    }
                }, 300);
            });
            
            $(window).on('scroll', function(e){
                if ( $(window).width() <= 1250 ) {
                    $('html, body').removeClass('disable-scrolling');
                    return;
                }

                let point_of_no_scroll = $(window).scrollTop() >= $('.nf-process-slider').offset().top && $(window).scrollTop() <= ($('.nf-process-slider').offset().top + 100);

                if ( $(window).height() <= 850 ) {
                    point_of_no_scroll = $(window).scrollTop() >= $('.nf-process-slider__wrapper').offset().top - 100 && $(window).scrollTop() <= ($('.nf-process-slider__wrapper').offset().top);
                }

                if ( point_of_no_scroll && ! $('html, body').hasClass('disable-scrolling') ) {
                    $('html, body').addClass('disable-scrolling');
                }
            });

            let is_navigating = false;

            $(window).on('wheel', function(e){
                if ( $(window).width() <= 1250 ) {
                    return;
                }

                if ( $('html, body').hasClass('disable-scrolling') && ! is_navigating ) {
                    is_navigating = true;
                    
                    if (e.originalEvent.wheelDelta > 0 || e.originalEvent.detail < 0) {
                        if ( $('.nf-process-slider__slides__item.active').index() === 0 ) {
                            $('html, body').removeClass( 'disable-scrolling' );
                            is_navigating = false;

                            return;
                        }

                        $('.nf-process-slider__slides__nav__prev').trigger('click');
                        
                        setTimeout(function(){
                            is_navigating = false;
                        }, 1000);
                    }
                    else {
                        if ( $('.nf-process-slider__slides__item.active').index() === 3 ) {
                            $('html, body').removeClass( 'disable-scrolling' );
                            is_navigating = false;

                            return;
                        }

                        $('.nf-process-slider__slides__nav__next').trigger('click');
                        
                        setTimeout(function(){
                            is_navigating = false;
                        }, 1000);
                    }
                }
            });
        }
    }
    
    if ( $('.nf-process-slider').length > 0 ) {
        (new ProcessSlider()).init();
    }
});